import {InjectionToken} from '@angular/core';
import {SharedConfig} from 'shared/lib/shared.config.interface';

export const SharedConfigToken = new InjectionToken<SharedConfig>('SharedConfig');
